import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '../editors/mui/Button';

const styles = {
  buttonStyle: {
    cursor: 'pointer',
    minWidth: '70px',
    height: '35px',
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: '2px 0 0 2px',
    margin: 0,
    // border: '1px solid #1875F0',
    zIndex: 0,
  },
  labelStyle: {
    color: '#1875F0',
    fontSize: 10,
  },
};

class InactiveFlatButton extends Component {
  render() {
    const { label, ...otherProps } = this.props;

    return (
      <Button rootStyle={styles.buttonStyle} variant="outlined" color="primary" {...otherProps}>
        <span style={styles.labelStyle}>{label}</span>
      </Button>
    );
  }
}

InactiveFlatButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default InactiveFlatButton;
